<div class="container pb-4">
  <app-shared-action-bar [saveReady]="hasChange && !isSaving" [undoReady]="hasChange && !isSaving"
    [displayActionSectionBar]="showActionSectionBar" (saveRequest)="save()"
  (undoRequest)="reset()"></app-shared-action-bar>




  <div class="px-4 md:px-8 mt-20">
    <div class="my-4">
      @if (!isGroup) {
        <h2 class="settings-header">Location Users</h2>
      }
      @if (isGroup) {
        <h2 class="settings-header">Location Groups</h2>
      }
    </div>
    <div class="">
      @if (showLocation) {
        <div class="py-2">
          @if (!topLevel && !isLocationSelected) {
            <div (click)="resetLocations()" class="hover:cursor-pointer flex">
              <span
              class="text-center material-symbols-outlined text-green-700 self-center mr-1 ">undo</span><span>Reset
            Locations</span>
          </div>
        }
        @if (locationsReady && !isLocationSelected) {
          <div>
            @for (l of possibleLocations; track l) {
              <div class="flex w-full my-2">
                <p class="p-2 md:p-4 flex-grow standardTextSize border-spacing-1.5 border-b-grey-500 border-s-2  flex justify-between align-middle "
                  [ngClass]="{'selected': l.LocationID == selectedLocation.LocationID, 'hover:hover-for-select  ':l.HasPermission, 'bg-grey-100 hover:cursor-not-allowed':!l.HasPermission,' bg-grey-300':l.HasPermission&&l.LocationID!=selectedLocation.LocationID}"
                  (click)="selectLocation(l)">{{l.LocationName}}@if (!l.Active) {
                  <span class="text-grey-900">
                  (Inactive)</span>
                }</p>
                @if (locationHasChildren(l)) {
                  <div class=" bg-standardwhite "
                    (click)="buildLocationDDL(l.LocationID)">
                    <span
                      class="standardTextSize text-offblack hover:hover-for-select bg-grey-300 border-grey-900 border-spacing-2 border-s h-full px-4 flex items-center">Sub
                    Locations</span>
                  </div>
                }
              </div>
            }
          </div>
        }

    </div>
  }
  @if (isLocationSelected) {
    <div class="flex-col mx-4 ">
      <div class="flex  mb-4 justify-between w-full md:w-2/5">
        <div class="flex  items-baseline">
          <p class="font-bold mr-4 text-green-700 text-xl">{{loadedLocation.LocationName}}@if (!loadedLocation.Active) {
            <span
            class="text-grey-900"> (Inactive)</span>
          }</p>
          <span class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub" (click)="resetSelectLocation()">undo</span>
        </div>
        <span class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub" (click)="changeDisplayOptions()">settings</span>
      </div>
      <div class="mt-2 border-solid ">
        @if (!showDisplayOptions) {
          <div class="flex flex-col mb-4">
            <p class="mr-2 mb-2 md:mb-0">Search</p>
            <input placeholder="Name" class="text-box w-full md:w-2/5" type="text" (keyup)="filterListByUser()"
              [(ngModel)]="filterUser" />
            @if (!isGroup) {
              <div class="flex items-center mt-3">
                <app-simple-toggle [(isChecked)]="showPermittedUsersOnly" (isCheckedChange)="filterListByUser()"></app-simple-toggle>
                <p class="ml-1">Show permitted only</p>
              </div>
            }
            </div>
          }
          @if (showDisplayOptions) {
            <div  class="p-2 border-grey-100 rounded-md border-2 md:w-2/5">
              <p class="text-green-400">Display</p>
              <div class="flex flex-col mt-2">
                <div class="flex ">
                  <app-simple-toggle [(isChecked)]="displayUsernames" (isCheckedChange)="filterListByUser()"></app-simple-toggle>
                  <p class="ml-1">Username</p>
                </div>
                <div class="flex mt-2">
                  <app-simple-toggle [(isChecked)]="displayEmails" (isCheckedChange)="filterListByUser()"></app-simple-toggle>
                  <p class="ml-1">Email</p>
                </div>
              </div>
            </div>
          }
          <table class="xl:w-1/5 lg:w-2/5 my-4 w-full">
            <thead>
              <tr class="pb-3">
                <th class="text-left">Name</th>
                @if (displayUsernames) {
                  <th class="text-left">Username</th>
                }
                @if (displayEmails) {
                  <th class="text-left">Email</th>
                }
                <th class="text-center">Location Permitted</th>
              </tr>
            </thead>
            <tbody>
              @for (u of filteredUserList; track u) {
                <tr>
                  <td  class="pr-1">
                    {{u.DisplayName}}
                  </td>
                  @if (displayUsernames) {
                    <td class="pr-1">
                      {{u.Username}}
                    </td>
                  }
                  @if (displayEmails) {
                    <td  class="pr-1">
                      {{u.Email}}
                    </td>
                  }
                  <td class="flex justify-center py-2">
                    <app-toggle-switch [(checked)]="u.Selected" (checkedChange)="checkForChanges()"></app-toggle-switch>
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <button class="btn-primary mr-4" (click)="save()" [disabled]="isSaving">
            @if (!isSaving) {
              <span>Save</span>
            }
            @if (isSaving) {
              <span>Saving...</span>
            }
          </button>
          <button class="btn-inverse" (click)="reset()" [disabled]="isSaving">Undo</button>
        </div>
      </div>
    }
  </div>
</div>

</div>
